import React from 'react';
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaPinterestP,
  FaSnapchatGhost,
  FaTiktok,
  FaRedditAlien,
  FaTelegramPlane,
  FaWhatsapp,
  FaDiscord,
} from 'react-icons/fa';

const socialLinks = {
  facebook: 'https://www.facebook.com/profile.php?id=61579706871955',
  twitter: 'https://x.com/PayStop',
  instagram: 'https://www.instagram.com/mypaystop/',
  youtube: 'https://www.youtube.com/@MyPayStop',
  linkedin: '',
  pinterest: '',
  snapchat: '',
  tiktok: 'ttps://www.tiktok.com/@mypaystop',
  reddit: '',
  telegram: '',
  whatsapp: '',
  discord: '',
};

const socialPlatforms = [
  { name: 'facebook', icon: FaFacebookF, color: 'bg-[#1877F2]' },
  { name: 'twitter', icon: FaTwitter, color: 'bg-[#1DA1F2]' },
  {
    name: 'instagram',
    icon: FaInstagram,
    color: 'bg-gradient-to-r from-yellow-400 via-red-500 to-purple-600',
  },
  { name: 'youtube', icon: FaYoutube, color: 'bg-[#FF0000]' },
  { name: 'linkedin', icon: FaLinkedinIn, color: 'bg-[#0077B5]' },
  { name: 'pinterest', icon: FaPinterestP, color: 'bg-[#E60023]' },
  { name: 'snapchat', icon: FaSnapchatGhost, color: 'bg-[#FFFC00] text-black' },
  { name: 'tiktok', icon: FaTiktok, color: 'bg-black' },
  { name: 'reddit', icon: FaRedditAlien, color: 'bg-[#FF4500]' },
  { name: 'telegram', icon: FaTelegramPlane, color: 'bg-[#0088CC]' },
  { name: 'whatsapp', icon: FaWhatsapp, color: 'bg-[#25D366]' },
  { name: 'discord', icon: FaDiscord, color: 'bg-[#5865F2]' },
];

const SocialMediaIcons: React.FC = () => {
  return (
    <div className="flex flex-wrap mt-4 space-x-3 sm:justify-center lg:mt-0">
      {socialPlatforms.map(({ name, icon: Icon, color }) => {
        const link = socialLinks[name as keyof typeof socialLinks];

        if (!link) return null;

        return (
          <a
            key={name}
            className={`w-8 h-8 rounded-full transition-all duration-500 flex justify-center items-center ${color} hover:bg-gray-900 text-white`}
            href={link}
            rel="noopener noreferrer"
            target="_blank"
          >
            <Icon className="w-4 h-4" />
          </a>
        );
      })}
    </div>
  );
};

export default SocialMediaIcons;
